<p-splitter *ngIf="this.app.inAppMode != true" #splitter id="mapComponentSplitter" [style]="{'height': '100%'}" [panelSizes]="panelSizes" [layout]="splitterLayout" [gutterSize]="splitterGutterSize" (onResizeEnd)="splitterMoved">
    <ng-template pTemplate>
        <div style="overflow-y: auto;" [style.maxHeight]="panelMaxHeight" [style.width]="panelWidth" id="auftragslistDiv">
            <app-auftragsdaten-list #auftragsdatenList id="auftragsdatenList" 
            [style.display]="fakeCRUDItem != null && fakeCRUDItem.auftraegeFiltered != null && viewType != 'mapOnly' ? unset : none"
            [mode]="mode"
            [parentCrudItem]="fakeCRUDItem" [parentComponent]="this"
            [crudItems]="fakeCRUDItem.auftraegefiltered"
            (crudItemsValueChange)="onCrudItemsValueChangeAuftraege($event)" [style.width]="'100%'"></app-auftragsdaten-list>
            <!--*ngIf="viewType != 'mapOnly'"-->
        </div>
        <div class="btnFloating">
            <button pButton type="button" label="debug" icon="fa-solid fa-debug" iconPos="left" style="float:left" (click)="debug()"></button>
        </div>
    </ng-template>
    <ng-template pTemplate>
        <div class="map-container" id="mapComponentMapContainer">
            <div class="map-frame">
                <div id="map"></div>
            </div>
        </div>
    </ng-template>
</p-splitter>
<div *ngIf="this.app.inAppMode == true" style="display: grid; gap: 0px;" style="{{inAppModeStyleGrid}}">
    <div class="map-container" id="mapComponentMapContainer" style="{{inAppModeStyleMapContainer}}"
    [style.display]="mode == 'map' && (fakeCRUDItem != null && fakeCRUDItem.auftraegeFiltered != null) ? 'unset' : 'none'"><!--mit topbar wären 50px-->
        <div class="map-frame" style="{{inAppModeStyleMapFrame}}"><!--mit topbar wären 50px-->
            <div id="map" style="{{inAppModeStyleMapMap}}"></div><!--mit topbar wären 50px, TODO: warum -2 ??? frame ???-->
        </div>
    </div>

    <div style="{{inAppModeStyleListContainer}}">
        <div id="auftragslistDiv" [style.display]="auftraegeListAppModeShow == true ? 'unset' : 'none'">
                <app-auftragsdaten-list #auftragsdatenList id="auftragsdatenList" 
                [style.display]="fakeCRUDItem != null && fakeCRUDItem.auftraegeFiltered != null ? 'unset' : 'none'"
                [mode]="mode"
                [parentCrudItem]="fakeCRUDItem" [parentComponent]="this"
                [crudItems]="fakeCRUDItem.auftraegefiltered"
                (crudItemsValueChange)="onCrudItemsValueChangeAuftraege($event)" [style.width]="'100%'"></app-auftragsdaten-list>
        </div>
    </div>

    <div class="btnFloating">
        <button pButton *ngIf="auftraegeListAppModeShow == true" style="padding: 0.25em; padding-right: 1em; margin-top: 0.25em;"
        type="button" label="Liste" iconPos="left" (click)="showList_changed('L')"><!--HIER war vor kurzem noch ein M statt L! Fehler? - siehe auch TS: ***FixAppReShowList-->
            <span class="fa-stack">
              <i class="fa-solid fa-list fa-stack-1x"></i>
              <i class=" fa-solid fa-slash fa-stack-1x"></i>
            </span>
        </button>
        <button pButton *ngIf="auftraegeListAppModeShow == false" type="button" label="Liste" icon="fa-solid fa-list" iconPos="left" (click)="showList_changed('L')">
        </button>
        <!--hideListeEinblendenButtonDiv: display wird programmtechnisch geschalten-->
        <div id="hideListeEinblendenButtonDiv" style="display: none; background-color: black; opacity: 0.75; position: relative; margin-top: -2.5em; z-index: 9999; width: 6.0em; height: 2.5em; text-align: center; border-radius: 4px;">
        <p-progressSpinner [style]="{width: '2em', height: '2em'}" strokeWidth="2"></p-progressSpinner>
        </div>
    </div>
</div>

<!--<button pButton type="button" label="debug" icon="fa-solid fa-debug" iconPos="left" style="float:left" (click)="debug()"></button>-->

<div class="dbgFloating" style="min-width: 17em; z-index: 99999; background-color: unset;" *ngIf="debugMode == true">
<!--
    <p-progressBar [value]="offlineFetchCounterProzent" [style]="{'height': '1em'}" [style.display]="offlineFetchCounterProzent > 0 && offlineFetchCounterProzent < 100 ? 'unset' : 'none'"></p-progressBar>
    <br>
    <button pButton type="button" class="p-button-danger" label="hide" style="font-size: 0.5em; min-width: unset;" (click)="offlineHideControls()">
    </button>
    <button pButton type="button" class="p-button-danger" label="show" style="font-size: 0.5em; min-width: unset;" (click)="offlineShowControls()">
    </button>
    <button pButton type="button" class="p-button-danger" label="D" style="font-size: 0.5em; min-width: unset;" (click)="offlineZoomD()">
    </button>
    <button pButton type="button" class="p-button-danger" label="save" style="font-size: 0.5em; min-width: unset;" (click)="offlineSaveTiles()">
    </button>
    <button pButton type="button" class="p-button-danger" label="erase" style="font-size: 0.5em; min-width: unset;" (click)="offlineRemoveTiles()">
    </button>
    <button pButton type="button" class="p-button-danger" label="onl." style="font-size: 0.5em; min-width: unset;" (click)="dbg_goOnline()">
    </button>
    <button pButton type="button" class="p-button-danger" label="offl." style="font-size: 0.5em; min-width: unset;" (click)="dbg_goOffline()">
    </button>
    <button pButton type="button" class="p-button-danger" label="storage" style="font-size: 0.5em; min-width: unset;" (click)="dbg_showOfflineStorage()">
    </button>
-->
    <span style="background-color: yellow; color: red">simulateNetworkIOS:{{simulateNetworkIOS}} simulateNetwork2g:{{simulateNetwork2g}}</span><br>
<!--    <button pButton type="button" class="p-button-danger" label="rmv LocalStor" style="font-size: 0.5em; min-width: unset;" (click)="dbg_localStorage_removeOfflineToggle()"></button>
    <button pButton type="button" class="p-button-danger" label="start on (ios)" style="font-size: 0.5em; min-width: unset;" (click)="dbg_start_on()"></button>
    <button pButton type="button" class="p-button-danger" label="start off (ios)" style="font-size: 0.5em; min-width: unset;" (click)="dbg_start_off()"></button>
    <button pButton type="button" class="p-button-danger" label="start w/o (and)" style="font-size: 0.5em; min-width: unset;" (click)="dbg_start_without_on_off()"></button>
    <button pButton type="button" class="p-button-danger" label="zoom 12" style="font-size: 0.5em; min-width: unset;" (click)="dbg_zoom_12()"></button>
    <button pButton type="button" class="p-button-danger" label="maui off" style="font-size: 0.5em; min-width: unset;" (click)="dbg_ConnectionChanged_from_MAUI_off()"></button>
    <button pButton type="button" class="p-button-danger" label="maui on" style="font-size: 0.5em; min-width: unset;" (click)="dbg_ConnectionChanged_from_MAUI_on()"></button>
    &nbsp;
    <button pButton type="button" class="p-button-danger" label="dbg map" style="font-size: 0.5em; min-width: unset;" (click)="dbg_Map()"></button>
    <button pButton type="button" class="p-button-danger" label="rmv lyr" style="font-size: 0.5em; min-width: unset;" (click)="dbg_removeLayer()"></button>
    <button pButton type="button" class="p-button-danger" label="add off" style="font-size: 0.5em; min-width: unset;" (click)="offlineToggleGoOffline()"></button>
    <button pButton type="button" class="p-button-danger" label="rmv mapMarkers" style="font-size: 0.5em; min-width: unset;" (click)="dbg_removeMapMarkers()"></button>
    <button pButton type="button" class="p-button-danger" label="rmv listItems" style="font-size: 0.5em; min-width: unset;" (click)="dbg_removeListItems()"></button>
    <button pButton type="button" class="p-button-danger" label="rmv map" style="font-size: 0.5em; min-width: unset;" (click)="dbg_removeMapTile()"></button>
    <button pButton type="button" class="p-button-danger" label="rmv mark" style="font-size: 0.5em; min-width: unset;" (click)="dbg_removeMarkers()"></button>
    <button pButton type="button" class="p-button-danger" label="fake it" style="font-size: 0.5em; min-width: unset;" (click)="dbg_fakeItems()"></button>
-->
    <!--<button pButton type="button" class="p-button-danger" label="fillList" style="font-size: 0.5em; min-width: unset;" (click)="dbg_fillList()"></button>-->
</div>

<div class="offlineToogleFloating leaflet-control" [style.display]="offlineEnable == true ? 'unset' : 'none'">
    <p-selectButton [options]="offlineToggleOptions" [(ngModel)]="offlineToggleSelected" optionLabel="name" styleClass="offlineToggle" [style]="{'max-height': '2.375em'}"
    (onChange)="offlineToogleChanged($event)"></p-selectButton>
</div>
  
<div class="btnFloating" *ngIf="this.app.inAppMode != true">
  <button pButton *ngIf="mode=='map' && alreadyAusgeblendet == false" style="padding: 0.25em; padding-right: 1em;    margin-top: 0.25em;"
  type="button" label="Liste ausblenden" iconPos="left" (click)="showList_changed('L')">
      <span class="fa-stack">
        <i class="fa-solid fa-list fa-stack-1x"></i>
        <i class=" fa-solid fa-slash fa-stack-1x"></i>
      </span>
  </button>
  <button pButton *ngIf="mode=='map' && alreadyAusgeblendet == true" type="button" label="Liste einblenden" icon="fa-solid fa-list" iconPos="left" (click)="showList_changed('L')">
  </button>
  <!--hideListeEinblendenButtonDiv: display wird programmtechnisch geschalten-->
  <div id="hideListeEinblendenButtonDiv" style="display: none; background-color: black; opacity: 0.75; position: relative; margin-top: -2.5em; z-index: 9999; width: 10.5em; height: 2.5em; text-align: center; border-radius: 4px;">
    <p-progressSpinner [style]="{width: '2em', height: '2em'}" strokeWidth="2"></p-progressSpinner>
  </div>

  <!-- Spezialfall: man kann auch im List-Mode die Liste ausblenden! -->
  <button pButton *ngIf="mode=='list' && alreadyAusgeblendet == false" style="padding: 0.25em; padding-right: 1em;    margin-top: 0.25em;"
  type="button" label="Liste ausblenden&nbsp;" iconPos="left" (click)="showList_changed('L')">
      <span class="fa-stack">
        <i class="fa-solid fa-list fa-stack-1x"></i>
        <i class=" fa-solid fa-slash fa-stack-1x"></i>
      </span>
  </button>
  <button pButton *ngIf="mode=='list' && alreadyAusgeblendet == true && alreadyAusgeblendetLastML=='L'" type="button" label="Liste einblenden" icon="fa-solid fa-list" iconPos="left" (click)="showList_changed('L')">
  </button>
  <span *ngIf="mode=='list'"><br></span>

  <button pButton *ngIf="mode=='list' && alreadyAusgeblendet == false" style="padding: 0.25em; padding-right: 1em;    margin-top: 0.25em;"
  type="button" label="Karte ausblenden" iconPos="left" (click)="showList_changed(undefined, true)">
      <span class="fa-stack">
        <i class="fa-solid fa-map fa-stack-1x"></i>
        <i class=" fa-solid fa-slash fa-stack-1x"></i>
      </span>
  </button>
  <button pButton *ngIf="mode=='list' && alreadyAusgeblendet == true && alreadyAusgeblendetLastML!='L'" type="button" label="Karte einblenden" icon="fa-solid fa-map" iconPos="left" (click)="showList_changed(undefined, true)">
  </button>
</div>

<app-topbar-replacement-for-app [style.display]="app.inAppMode == true ? 'unset' : 'none'"></app-topbar-replacement-for-app>

<!--<div id="progressBarNoTransitionDiv" class="loadingMarkersProgressFloating" style="display: none;">
    <p-progressBar id="progressBarNoTransition" [value]="loadingMarkersProzent" [style]="{'height': '16px', 'font-size': app.inAppMode ? '0.8em' : 'unset'}"></p-progressBar>
</div>-->

<p-dialog #AuftragsDetailContainer [(visible)]="dialogAuftragShow" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">
    <ng-template pTemplate="header">
        <div class="details-grid-container">
            <!-- zeile 1 -->
            <div>
                <i class="fa fa-{{ getLeistungForAuftrag(lastclickedAuftrag).icon }} fa-xl"></i>
            </div>
            <div title="{{lastclickedAuftrag.id}}">
                <big>{{ getLeistungForAuftrag(lastclickedAuftrag).bezeichnung }}:</big>
                <small *ngIf="debugMode==true"> {{lastclickedAuftrag.id}}</small>
            </div>
        </div>
        <button *ngIf="app.inAppMode!=true" pButton type="button" icon="fa-solid fa-print" iconPos="left"  style="position: fixed; top: 14px; right: 50px;" (click)="printDetails()"></button>
    </ng-template>
    <ng-container *ngIf="lastclickedAuftrag != null">
        <div class="details-grid-container">
            <!-- Überschrift -->
            <div [style.display]="sichtbar('lblUeberschriftBehaelterstandort') ? 'unset' : 'none'" class="details-ueberschrift-left">
                &nbsp;
            </div>
            <div [style.display]="sichtbar('lblUeberschriftBehaelterstandort') ? 'unset' : 'none'" class="details-ueberschrift-right">
                Behälterstandort
            </div>
        </div>
        <div class="details-grid-container-with-right" style="margin-top: 1em;">
            <!-- zeile 1: Behälterstandort -->
            <div>
                <i class="fa fa-location"></i>
            </div>
            <div pTooltip="Standort" tooltipPosition="left">
                {{lastclickedAuftrag.name_1Behaelterstandort}} {{lastclickedAuftrag.name_2Behaelterstandort}}<br>
                {{lastclickedAuftrag.strasseBehaelterstandort}}<br>
                {{lastclickedAuftrag.plzBehaelterstandort}} {{lastclickedAuftrag.ortBehaelterstandort}} {{lastclickedAuftrag.ortzusatzBehaelterstandort}}
            </div>
            <div>
                <button *ngIf="sichtbar('btnBehaelterstandort')" pButton type="button" label="Behälterstandort" icon="fa-solid fa-edit" iconPos="left" style="float:right" (click)="behaelterstandortAendernClicked(lastclickedAuftrag)"></button>
            </div>
        </div>
        <div class="details-grid-container">
            <!-- nächste -->
            <div *ngIf="lastclickedAuftrag.telefonBehaelterstandort != null && lastclickedAuftrag.telefonBehaelterstandort.length > 0">
                <i class="fa-solid fa-phone"></i>
            </div>
            <div *ngIf="lastclickedAuftrag.telefonBehaelterstandort != null && lastclickedAuftrag.telefonBehaelterstandort.length > 0" pTooltip="Telefon" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonBehaelterstandort | phoneCanonical}}">{{lastclickedAuftrag.telefonBehaelterstandort | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonBehaelterstandort)">{{lastclickedAuftrag.telefonBehaelterstandort | phoneCanonical}}</a>
            </div>
            <!-- Tel. geschäftlich -->
            <div *ngIf="sichtbar('lblTelefonGeschaeftlichBehaelterstandort') && lastclickedAuftrag.telefonGeschaeftlichBehaelterstandort != null && lastclickedAuftrag.telefonGeschaeftlichBehaelterstandort != telefonBehaelterstandort">
                <i class="fa-solid fa-briefcase"></i>
            </div>
            <div *ngIf="sichtbar('lblTelefonGeschaeftlichBehaelterstandort') && lastclickedAuftrag.telefonGeschaeftlichBehaelterstandort != null && lastclickedAuftrag.telefonGeschaeftlichBehaelterstandort != telefonBehaelterstandort" pTooltip="Telefon geschäftlich" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonGeschaeftlichBehaelterstandort | phoneCanonical}}">{{lastclickedAuftrag.telefonGeschaeftlichBehaelterstandort | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonGeschaeftlichBehaelterstandort)">{{lastclickedAuftrag.telefonGeschaeftlichBehaelterstandort | phoneCanonical}}</a>
            </div>
            <!-- Tel. privat -->
            <div *ngIf="sichtbar('lblTelefonPrivatBehaelterstandort') && lastclickedAuftrag.telefonPrivatBehaelterstandort != null && lastclickedAuftrag.telefonPrivatBehaelterstandort != telefonBehaelterstandort">
                <i class="fa-solid fa-phone"></i>
            </div>
            <div *ngIf="sichtbar('lblTelefonPrivatBehaelterstandort') && lastclickedAuftrag.telefonPrivatBehaelterstandort != null && lastclickedAuftrag.telefonPrivatBehaelterstandort != telefonBehaelterstandort" pTooltip="Telefon privat" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonPrivatBehaelterstandort | phoneCanonical}}">{{lastclickedAuftrag.telefonPrivatBehaelterstandort | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonPrivatBehaelterstandort)">{{lastclickedAuftrag.telefonPrivatBehaelterstandort | phoneCanonical}}</a>
            </div>
            <!-- Tel. mobil -->
            <div *ngIf="sichtbar('lblTelefonMobilBehaelterstandort') && lastclickedAuftrag.telefonMobilBehaelterstandort != null && lastclickedAuftrag.telefonMobilBehaelterstandort != telefonBehaelterstandort">
                <i class="fa-solid fa-mobile"></i>
            </div>
            <div *ngIf="sichtbar('lblTelefonMobilBehaelterstandort') && lastclickedAuftrag.telefonMobilBehaelterstandort != null && lastclickedAuftrag.telefonMobilBehaelterstandort != telefonBehaelterstandort" pTooltip="Telefon mobil" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonMobilBehaelterstandort | phoneCanonical}}">{{lastclickedAuftrag.telefonMobilBehaelterstandort | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonMobilBehaelterstandort)">{{lastclickedAuftrag.telefonMobilBehaelterstandort | phoneCanonical}}</a>
            </div>
            <!-- eMail -->
            <div *ngIf="sichtbar('lblEmailBehaelterstandort') && lastclickedAuftrag.eMailBehaelterstandort != null">
                <i class="fa-solid fa-envelope"></i>
            </div>
            <div *ngIf="sichtbar('lblEmailBehaelterstandort') && lastclickedAuftrag.eMailBehaelterstandort != null" pTooltip="E-Mail" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true && lastclickedAuftrag.eMailBehaelterstandort != null" href="mailto:{{lastclickedAuftrag.eMailBehaelterstandort}}">{{lastclickedAuftrag.eMailBehaelterstandort}}</a>
                <a *ngIf="app.inAppMode==true && lastclickedAuftrag.eMailBehaelterstandort != null" style="cursor: pointer" (click)="eMailClicked(lastclickedAuftrag.eMailBehaelterstandort)">{{lastclickedAuftrag.eMailBehaelterstandort}}</a>
            </div>

        </div>

        <div class="details-grid-container" style="margin-top: 1em;"
        *ngIf="((lastclickedAuftrag.name_1Ansprechpartner != null && lastclickedAuftrag.name_1Ansprechpartner.length > 0) || (lastclickedAuftrag.name_2Ansprechpartner != null && lastclickedAuftrag.name_2Ansprechpartner.length > 0)) && sichtbar('lblUeberschriftAnsprechpartner')">
            <!-- Überschrift -->
            <div class="details-ueberschrift-left">
                &nbsp;
            </div>
            <div class="details-ueberschrift-right">
                Ansprechpartner
            </div>
        </div>
        <div class="details-grid-container-with-right" *ngIf="(lastclickedAuftrag.name_1Ansprechpartner != null && lastclickedAuftrag.name_1Ansprechpartner.length > 0) || (lastclickedAuftrag.name_2Ansprechpartner != null && lastclickedAuftrag.name_2Ansprechpartner.length > 0)">
            <!-- nächste: Ansprechpartner -->
            <div>
                <div style="min-height: 1.25em;"></div>
                <i class="fa-solid fa-user"></i>
            </div>
            <div pTooltip="Ansprechpartner" tooltipPosition="left">
                <div style="min-height: 1.25em;"></div>
                {{lastclickedAuftrag.name_1Ansprechpartner }} {{lastclickedAuftrag.name_2Ansprechpartner}}
                <!-- US 38105 Name Ansprechpartner wird auch angezeigt wenn nur name_2Ansprechpartner vorhanden ist -->
                <!--     {{lastclickedAuftrag.name_1Ansprechpartner != null ? lastclickedAuftrag.name_1Ansprechpartner : lastclickedAuftrag.name_1Kunde}} {{lastclickedAuftrag.name_1Ansprechpartner != null ? lastclickedAuftrag.name_2Ansprechpartner : lastclickedAuftrag.name_2Kunde}} -->
                
                <!-- das ist absicht, dass die 2. condition ebenfalls auf name1 abfrägt!!!-->
                <!--{{lastclickedAuftrag.strasseKunde}}<br>
                {{lastclickedAuftrag.plzKunde}}<br> {{lastclickedAuftrag.ortKunde}}-->
            </div>
            <div style="position: relative;">
                <button pButton type="button" label="{{ (app.inAppMode!=true) ? 'techn. Ansprechpartner' :'Änderung' }}" icon="fa-solid fa-edit" iconPos="left" style="float:right; position: absolute; bottom: 0;" (click)="stammdatenAendernClicked(lastclickedAuftrag)"></button>
            </div>
        </div>   
        <div class="details-grid-container" style="margin-top: 10px;">
            <!-- nächste -->
            <div *ngIf="lastclickedAuftrag.telefonAnsprechpartner != null && lastclickedAuftrag.telefonAnsprechpartner.length > 0">
                <i class="fa-solid fa-phone"></i>
            </div>
            <div *ngIf="lastclickedAuftrag.telefonAnsprechpartner != null && lastclickedAuftrag.telefonAnsprechpartner.length > 0" pTooltip="Telefon" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true && lastclickedAuftrag.telefonAnsprechpartner != null" href="tel:{{lastclickedAuftrag.telefonAnsprechpartner | phoneCanonical}}">{{lastclickedAuftrag.telefonAnsprechpartner | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true && lastclickedAuftrag.telefonAnsprechpartner != null" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonAnsprechpartner)">{{lastclickedAuftrag.telefonAnsprechpartner | phoneCanonical}}</a>
            </div>
            <!-- Tel. geschäftlich -->
            <div *ngIf="sichtbar('lblTelefonGeschaeftlichAnsprechpartner') && lastclickedAuftrag.telefonGeschaeftlichAnsprechpartner != null && lastclickedAuftrag.telefonGeschaeftlichAnsprechpartner != telefonAnsprechpartner">
                <i class="fa-solid fa-briefcase"></i>
            </div>
            <div *ngIf="sichtbar('lblTelefonGeschaeftlichAnsprechpartner') && lastclickedAuftrag.telefonGeschaeftlichAnsprechpartner != null && lastclickedAuftrag.telefonGeschaeftlichAnsprechpartner != telefonAnsprechpartner" pTooltip="Telefon geschäftlich" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonGeschaeftlichAnsprechpartner | phoneCanonical}}">{{lastclickedAuftrag.telefonGeschaeftlichAnsprechpartner | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonGeschaeftlichAnsprechpartner)">{{lastclickedAuftrag.telefonGeschaeftlichAnsprechpartner | phoneCanonical}}</a>
            </div>
            <!-- Tel. privat -->
            <div *ngIf="sichtbar('lblTelefonPrivatAnsprechpartner') && lastclickedAuftrag.telefonPrivatAnsprechpartner != null && lastclickedAuftrag.telefonPrivatAnsprechpartner != telefonAnsprechpartner">
                <i class="fa-solid fa-phone"></i>
            </div>
            <div *ngIf="sichtbar('lblTelefonPrivatAnsprechpartner') && lastclickedAuftrag.telefonPrivatAnsprechpartner != null && lastclickedAuftrag.telefonPrivatAnsprechpartner != telefonAnsprechpartner" pTooltip="Telefon privat" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonPrivatAnsprechpartner | phoneCanonical}}">{{lastclickedAuftrag.telefonPrivatAnsprechpartner | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonPrivatAnsprechpartner)">{{lastclickedAuftrag.telefonPrivatAnsprechpartner | phoneCanonical}}</a>
            </div>
            <!-- Tel. mobil -->
            <div *ngIf="sichtbar('lblTelefonMobilAnsprechpartner') && lastclickedAuftrag.telefonMobilAnsprechpartner != null && lastclickedAuftrag.telefonMobilAnsprechpartner != telefonAnsprechpartner">
                <i class="fa-solid fa-mobile"></i>
            </div>
            <div *ngIf="sichtbar('lblTelefonMobilAnsprechpartner') && lastclickedAuftrag.telefonMobilAnsprechpartner != null && lastclickedAuftrag.telefonMobilAnsprechpartner != telefonAnsprechpartner" pTooltip="Telefon mobil" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonMobilAnsprechpartner | phoneCanonical}}">{{lastclickedAuftrag.telefonMobilAnsprechpartner | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonMobilAnsprechpartner)">{{lastclickedAuftrag.telefonMobilAnsprechpartner | phoneCanonical}}</a>
            </div>
            <!-- email -->
            <div *ngIf="lastclickedAuftrag.eMailAnsprechpartner != null && lastclickedAuftrag.eMailAnsprechpartner.length > 0">
                <i class="fa-solid fa-envelope"></i>
            </div>
            <div *ngIf="lastclickedAuftrag.eMailAnsprechpartner != null && lastclickedAuftrag.eMailAnsprechpartner.length > 0" pTooltip="E-Mail" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true && lastclickedAuftrag.eMailAnsprechpartner != null" href="mailto:{{lastclickedAuftrag.eMailAnsprechpartner}}">{{lastclickedAuftrag.eMailAnsprechpartner}}</a>
                <a *ngIf="app.inAppMode==true && lastclickedAuftrag.eMailAnsprechpartner != null" style="cursor: pointer" (click)="eMailClicked(lastclickedAuftrag.eMailAnsprechpartner)">{{lastclickedAuftrag.eMailAnsprechpartner}}</a>
            </div>

            <!-- nächste: Ansprechpartner Versorger -->
            <div>
                <br>
                <i class="fa-solid fa-building"></i>
            </div>
            <div>
                <br>
                <!--???-->{{versorgerAnsprechpartnerText}}<!--???--><br>
                <!--{{lastclickedAuftrag.name_2Kunde}}<br *ngIf="lastclickedAuftrag.name_2Kunde != null">-->
                <!--{{lastclickedAuftrag.strasseKunde}}<br>
                {{lastclickedAuftrag.plzKunde}}<br> {{lastclickedAuftrag.ortKunde}}-->
            </div>

            <!-- Überschrift -->
            <div *ngIf="sichtbar('lblUeberschriftRechnungsadresseKunde')" class="details-ueberschrift-left">
                &nbsp;
            </div>
            <div *ngIf="sichtbar('lblUeberschriftRechnungsadresseKunde')" class="details-ueberschrift-right">
                Rechnungsadresse
            </div>
            
            <div [style.display]="sichtbar('lblRechnungsadresseKunde') ? 'unset' : 'none'">
                <!--<br>-->
                <i class="fa-solid fa-money-bill"></i>
            </div>
            <div [style.display]="sichtbar('lblRechnungsadresseKunde') ? 'unset' : 'none'" pTooltip="Kunde" tooltipPosition="left">
                <!--<br>-->
                {{lastclickedAuftrag.name_1Kunde}} {{lastclickedAuftrag.name_2Kunde}}<br>
                {{lastclickedAuftrag.strasseKunde}}<br>
                {{lastclickedAuftrag.plzKunde}} {{lastclickedAuftrag.ortKunde}} {{lastclickedAuftrag.ortzusatzKunde}}
            </div>
            <!-- nächste -->
            <div *ngIf="lastclickedAuftrag.telefonKunde != null">
                <i class="fa-solid fa-phone"></i>
            </div>
            <div *ngIf="lastclickedAuftrag.telefonKunde != null" pTooltip="Telefon" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true && lastclickedAuftrag_Checkliste != null" href="tel:{{lastclickedAuftrag_Checkliste.imAuftragTelefon | phoneCanonical}}">{{lastclickedAuftrag_Checkliste.imAuftragTelefon | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true && lastclickedAuftrag_Checkliste != null" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag_Checkliste.imAuftragTelefon)">{{lastclickedAuftrag_Checkliste.imAuftragTelefon | phoneCanonical}}</a>
            </div>
            <!-- Tel. geschäftlich -->
            <div *ngIf="sichtbar('lblTelefonGeschaeftlichKunde') && lastclickedAuftrag.telefonGeschaeftlichKunde != null && lastclickedAuftrag.telefonGeschaeftlichKunde != telefonKunde">
                <i class="fa-solid fa-briefcase"></i>
            </div>
            <div *ngIf="sichtbar('lblTelefonGeschaeftlichKunde') && lastclickedAuftrag.telefonGeschaeftlichKunde != null && lastclickedAuftrag.telefonGeschaeftlichKunde != telefonKunde" pTooltip="Telefon geschäftlich" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonGeschaeftlichKunde | phoneCanonical}}">{{lastclickedAuftrag.telefonGeschaeftlichKunde | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonGeschaeftlichKunde)">{{lastclickedAuftrag.telefonGeschaeftlichKunde | phoneCanonical}}</a>
            </div>
            <!-- Tel. privat -->
            <div *ngIf="sichtbar('lblTelefonPrivatKunde') && lastclickedAuftrag.telefonPrivatKunde != null && lastclickedAuftrag.telefonPrivatKunde != telefonKunde">
                <i class="fa-solid fa-phone"></i>
            </div>
            <div *ngIf="sichtbar('lblTelefonPrivatKunde') && lastclickedAuftrag.telefonPrivatKunde != null && lastclickedAuftrag.telefonPrivatKunde != telefonKunde" pTooltip="Telefon privat" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonPrivatKunde | phoneCanonical}}">{{lastclickedAuftrag.telefonPrivatKunde | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonPrivatKunde)">{{lastclickedAuftrag.telefonPrivatKunde | phoneCanonical}}</a>
            </div>
            <!-- Tel. mobil -->
            <div *ngIf="sichtbar('lblTelefonMobilKunde') && lastclickedAuftrag.telefonMobilKunde != null && lastclickedAuftrag.telefonMobilKunde != telefonKunde">
                <i class="fa-solid fa-mobile"></i>
            </div>
            <div *ngIf="sichtbar('lblTelefonMobilKunde') && lastclickedAuftrag.telefonMobilKunde != null && lastclickedAuftrag.telefonMobilKunde != telefonKunde" pTooltip="Telefon mobil" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonMobilKunde | phoneCanonical}}">{{lastclickedAuftrag.telefonMobilKunde | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonMobilKunde)">{{lastclickedAuftrag.telefonMobilKunde | phoneCanonical}}</a>
            </div>
            <!-- email -->
            <div *ngIf="sichtbar('lblEmailKunde') && lastclickedAuftrag.eMailKunde != null">
                <i class="fa-solid fa-envelope"></i>
            </div>
            <div *ngIf="sichtbar('lblEmailKunde') && lastclickedAuftrag.eMailKunde != null" pTooltip="E-Mail" tooltipPosition="left">
                <a *ngIf="app.inAppMode!=true && lastclickedAuftrag.eMailKunde != null" href="mailto:{{lastclickedAuftrag.eMailKunde}}">{{lastclickedAuftrag.eMailKunde}}</a>
                <a *ngIf="app.inAppMode==true && lastclickedAuftrag.eMailKunde != null" style="cursor: pointer" (click)="eMailClicked(lastclickedAuftrag.eMailKunde)">{{lastclickedAuftrag.eMailKunde}}</a>
            </div>

            <!-- Auftrags Dokumente Var 1 -->            
            <div *ngIf="lastclickedAuftrag?.auftragsDokumente?.length && sichtbar('lblUeberschriftAuftragsDokumente')" class="details-ueberschrift-left">
                &nbsp;
            </div>
            <div *ngIf="lastclickedAuftrag?.auftragsDokumente?.length && sichtbar('lblUeberschriftAuftragsDokumente')" class="details-ueberschrift-right">
                Verknüpfte Auftrags Dokumente ({{lastclickedAuftrag.auftragsDokumente.length}})
            </div>

            <div *ngIf="lastclickedAuftrag?.auftragsDokumente?.length && sichtbar('lblAuftragsDokumente')">
                &nbsp;
            </div>

            <table *ngIf="lastclickedAuftrag?.auftragsDokumente?.length && sichtbar('lblAuftragsDokumente')" class="aufrags-dokumente-table" style="margin-top: 10px;">
                <thead>
                    <tr>
                        <th>Datei </th>
                        <th>Format</th>
                        <th>Stand</th>
                        <th style="width: 90px;">Download</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let auftrDok of lastclickedAuftrag.auftragsDokumente; let i = index">
                        <td>{{auftrDok.bezeichnung}}</td>
                        <td>{{auftrDok.dateiendung}}</td>
                        <td>{{auftrDok.modified | datumFormat:'DD.MM.YYYY':true}}</td>
                        <td><button pButton type="button" icon="fa-solid fa-download" iconPos="left" (click)="downloadAuftragsDokument(auftrDok.id)"></button></td>
                    </tr>
                </tbody>
            </table>      

            <!-- Auftrags Dokumente Var 2 -->            
            <div *ngIf="lastclickedAuftrag?.auftragsDokumente?.length" style="color: red;">
                <i class="fa-solid fa-circle-info"></i>
            </div>
            <div  *ngIf="lastclickedAuftrag?.auftragsDokumente?.length">                
                <span style="color: red; font-weight: bold;">Verknüpfte Dokumente vorhanden </span>
                <button  pButton type="button" icon="fa-solid fa-file" (click)="toggelDokumenteDialogShow()" [label]="app.inAppMode ? null : 'Dokumente (' + lastclickedAuftrag.auftragsDokumente.length + ')'" style="float:right" ></button>                
            </div>
      
            <!-- Überschrift -->
            <div *ngIf="sichtbar('lblUeberschriftAuftragsdetails')" class="details-ueberschrift-left">
                &nbsp;
                <div style="font-size: 0.25em;">
                    <br>
                </div>
            </div>
            <div *ngIf="sichtbar('lblUeberschriftAuftragsdetails')" class="details-ueberschrift-right">
                Auftragsdetails
                <div style="font-size: 0.25em;">
                    <br>
                </div>
            </div>
                
            <!-- nächste: Disponiert -->
            <div *ngIf="lastclickedAuftrag.dispodatum != null || lastclickedAuftrag.benutzerId != null">
                <div style="font-size: 0.25em;">
                    <br *ngIf="!(sichtbar('lblDispodatum'))"><!--nur wenn nicht schon Abstand durch Überschrift-->
                </div>
                <i class="fa-regular fa-calendar"></i>
            </div>
            <div *ngIf="lastclickedAuftrag.dispodatum != null || lastclickedAuftrag.benutzerId != null" pTooltip="Disponiert" tooltipPosition="left">
                <div style="font-size: 0.25em;">
                    <br *ngIf="!(sichtbar('lblDispodatum'))"><!--nur wenn nicht schon Abstand durch Überschrift-->
                </div>
                Disponiert: {{lastclickedAuftrag.dispodatum | datumOhneZeit}} {{lastclickedAuftrag.dispozeit != null ? lastclickedAuftrag.dispozeit.substring(0,5)+" " : ""}}{{lastclickedAuftrag.benutzerId | benutzer}}
            </div>
            <div *ngIf="lastclickedAuftrag.wiedervorlage != null" pTooltip="Wiedervorlage" tooltipPosition="left">
                <i class="fa-solid fa-alarm-clock"></i>
            </div>
            <div *ngIf="lastclickedAuftrag.wiedervorlage != null">
                Wiedervorlage: {{lastclickedAuftrag.wiedervorlage | datumOhneZeit:['/noUTC']}}
            </div>

            <!-- nächste: "Aufkleber" -->
            <div style="color: red;" *ngIf="(getLeistungForAuftrag(lastclickedAuftrag).anstrich == true || getLeistungForAuftrag(lastclickedAuftrag).typ == 'Anstriche') && aufkleberVertragsartenKeinAufkleber != null && aufkleberVertragsartenKeinAufkleber.length > 0 && lastclickedAuftrag != null">
                <i class="fa-solid fa-circle-info"></i>
            </div>
            <div style="color: red; font-weight: bold;" *ngIf="(getLeistungForAuftrag(lastclickedAuftrag).anstrich == true || getLeistungForAuftrag(lastclickedAuftrag).typ == 'Anstriche') && aufkleberVertragsartenKeinAufkleber != null && aufkleberVertragsartenKeinAufkleber.length > 0 && lastclickedAuftrag != null">
                <!--<small>DEBUG: auftragId:{{lastclickedAuftrag.id}} vertragsartenKEINAufkleber:{{aufkleberVertragsartenKeinAufkleber}} vertragsart:{{lastclickedAuftrag.verwaltungsdaten}} textKEINAufkleber:{{aufkleberTextKeinAufkleber}} textAufkleber:{{aufkleberTextAufkleber}}<br></small>-->
                <span innerHTML="{{aufkleberVertragsartenKeinAufkleber.indexOf('\''+lastclickedAuftrag.verwaltungsdaten+'\'') > -1 ? aufkleberTextKeinAufkleber : aufkleberTextAufkleber}}"></span>
            </div>
            
            <!-- nächste: Bemerkung -->
            <div style="color: red;" *ngIf="lastclickedAuftrag.auftragsbemerkung != null && lastclickedAuftrag.auftragsbemerkung.length > 0">
                <i class="fa-solid fa-circle-info"></i>
            </div>
            <div style="color: red; font-weight: bold;" *ngIf="lastclickedAuftrag.auftragsbemerkung != null && lastclickedAuftrag.auftragsbemerkung.length > 0">
                {{lastclickedAuftrag.auftragsbemerkung}}
            </div>

            <!-- nächste: Notizen -->
            <div *ngIf="lastclickedAuftrag.notizDienstleister != null && lastclickedAuftrag.notizDienstleister.length > 0 || sichtbar('lblNotizDienstleister') && this.app.inAppMode == false">
                <i *ngIf="lastclickedAuftrag.notizDienstleister != null && lastclickedAuftrag.notizDienstleister.length > 0" class="fa-solid fa-circle-info"></i>
            </div>
            <div *ngIf="lastclickedAuftrag.notizDienstleister != null && lastclickedAuftrag.notizDienstleister.length > 0 || sichtbar('lblNotizDienstleister') && this.app.inAppMode == false">
                {{lastclickedAuftrag.notizDienstleister}}
                <button *ngIf="sichtbar('btnNotizDienstleister')" pButton type="button" label="{{lastclickedAuftrag.notizDienstleister != null && lastclickedAuftrag.notizDienstleister.length > 0 ? 'Notiz ändern' : 'Notiz'}}" icon="fa-solid fa-edit" iconPos="left" style="float:right" (click)="notizAendernClicked(lastclickedAuftrag)"></button>
            </div>

        </div>

        <!-- Vertriebsbüro: -->
        <div class="details-grid-container" *ngIf="lastclickedAuftrag.vertriebsbuero != null && lastclickedAuftrag.vertriebsbuero.length > 0">
            <div class="details-ueberschrift-left">
                <i class="fa-regular fa-shop"></i>&nbsp;
            </div>
            <div class="details-ueberschrift-right">
                Vertriebsbüro
            </div>

            <div>
                <!--icon?-->&nbsp;
            </div>
            <div style="width: 100%">
                
                <div class="" [ngClass]="{'details-grid-tablelike-container': !app.inAppMode, 'details-grid-tablelike-container-inAppMode': app.inAppMode}">

                    <div *ngIf="lastclickedAuftrag.vertriebsbuero != null">
                        Vertriebsbüro:
                    </div>
                    <div *ngIf="lastclickedAuftrag.vertriebsbuero != null">
                        {{lastclickedAuftrag.vertriebsbuero}}
                    </div>
                    
                    <div *ngIf="lastclickedAuftrag.vertriebsbuero_Mitarbeiter != null">
                        Mitarbeiter:
                    </div>
                    <div *ngIf="lastclickedAuftrag.vertriebsbuero_Mitarbeiter != null">
                        {{lastclickedAuftrag.vertriebsbuero_Mitarbeiter}}
                    </div>
                    
                    <div *ngIf="lastclickedAuftrag.vertriebsbuero_LeiterRegion != null">
                        Leiter Region:
                    </div>
                    <div *ngIf="lastclickedAuftrag.vertriebsbuero_LeiterRegion != null">
                        {{lastclickedAuftrag.vertriebsbuero_LeiterRegion}}
                    </div>
                    
                    <div *ngIf="lastclickedAuftrag.vertriebsbuero_Vertrag_durch != null">
                        Vertrag durch:
                    </div>
                    <div *ngIf="lastclickedAuftrag.vertriebsbuero_Vertrag_durch != null">
                        {{lastclickedAuftrag.vertriebsbuero_Vertrag_durch}}
                    </div>

                    <div *ngIf="lastclickedAuftrag.vertriebsbuero_TelefonMobil != null">
                        Telefon Mobil:
                    </div>
                    <div *ngIf="lastclickedAuftrag.vertriebsbuero_TelefonMobil != null">
                        {{lastclickedAuftrag.vertriebsbuero_TelefonMobil}}
                    </div>

                    <div *ngIf="lastclickedAuftrag.vertriebsbuero_Telefax != null">
                        Telefax:
                    </div>
                    <div *ngIf="lastclickedAuftrag.vertriebsbuero_Telefax != null">
                        {{lastclickedAuftrag.vertriebsbuero_Telefax}}
                    </div>

                </div>
            </div>

        </div>
        <!-- Ende Vertriebsbüro -->

        <!-- Dispodaten: -->
        <div class="details-grid-container" *ngIf="dispositionskennzeichen_bezeichnungen[0] != null || lastclickedAuftrag.fixtermin != null || lastclickedAuftrag.fundamentplatten != null">
            <div class="details-ueberschrift-left">
                <i class="fa-regular fa-list-check"></i>&nbsp;
            </div>
            <div class="details-ueberschrift-right">
                Disposition
            </div>

            <div>
                <!--icon?-->&nbsp;
            </div>
            <div style="width: 100%">
                
                <div class="" [ngClass]="{'details-grid-tablelike-container': !app.inAppMode, 'details-grid-tablelike-container-inAppMode': app.inAppMode}">
                    <div *ngIf="lastclickedAuftrag.fixtermin == true">
                        Fixtermin:
                    </div>
                    <div *ngIf="lastclickedAuftrag.fixtermin == true">
                        <div class="details-hervorheben">{{lastclickedAuftrag.auftragsdatum | datumFormat:'DD.MM.YYYY':true}}</div>
                    </div>

                    <div *ngIf="lastclickedAuftrag.fundamentplatten != null">
                        Fundamentplatten:
                    </div>
                    <div *ngIf="lastclickedAuftrag.fundamentplatten != null">
                        {{lastclickedAuftrag.fundamentplatten}}
                    </div>
                </div>

                <div class="" [ngClass]="{'details-grid-tablelike-container': !app.inAppMode, 'details-grid-tablelike-container-inAppMode': app.inAppMode}">
                    <div *ngIf="lastclickedAuftrag.dispokennzeichen_1 != null"> <!-- #39321 Kennzeichen nur anzeigen, wenn nicht leer -->
                        <p-checkbox *ngIf="lastclickedAuftrag.dispokennzeichen_1 == true" label="{{ dispositionskennzeichen_bezeichnungen[0] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.dispokennzeichen_1 == true)" label="{{ dispositionskennzeichen_bezeichnungen[0] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div *ngIf="lastclickedAuftrag.dispokennzeichen_2 != null"> <!-- #39321 Kennzeichen nur anzeigen, wenn nicht leer -->
                        <p-checkbox *ngIf="lastclickedAuftrag.dispokennzeichen_2 == true" label="{{ dispositionskennzeichen_bezeichnungen[1] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.dispokennzeichen_2 == true)" label="{{ dispositionskennzeichen_bezeichnungen[1] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div *ngIf="lastclickedAuftrag.dispokennzeichen_3 != null"> <!-- #39321 Kennzeichen nur anzeigen, wenn nicht leer -->
                        <p-checkbox *ngIf="lastclickedAuftrag.dispokennzeichen_3 == true" label="{{ dispositionskennzeichen_bezeichnungen[2] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.dispokennzeichen_3 == true)" label="{{ dispositionskennzeichen_bezeichnungen[2] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div *ngIf="lastclickedAuftrag.dispokennzeichen_4 != null"> <!-- #39321 Kennzeichen nur anzeigen, wenn nicht leer -->
                        <p-checkbox *ngIf="lastclickedAuftrag.dispokennzeichen_4 == true" label="{{ dispositionskennzeichen_bezeichnungen[3] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.dispokennzeichen_4 == true)" label="{{ dispositionskennzeichen_bezeichnungen[3] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <!-- nä. zeile -->
                    <div *ngIf="lastclickedAuftrag.dispokennzeichen_5 != null"> <!-- #39321 Kennzeichen nur anzeigen, wenn nicht leer -->
                        <p-checkbox *ngIf="lastclickedAuftrag.dispokennzeichen_5 == true" label="{{ dispositionskennzeichen_bezeichnungen[4] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.dispokennzeichen_5 == true)" label="{{ dispositionskennzeichen_bezeichnungen[4] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div *ngIf="lastclickedAuftrag.dispokennzeichen_6 != null"> <!-- #39321 Kennzeichen nur anzeigen, wenn nicht leer -->
                        <p-checkbox *ngIf="lastclickedAuftrag.dispokennzeichen_6 == true" label="{{ dispositionskennzeichen_bezeichnungen[5] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.dispokennzeichen_6 == true)" label="{{ dispositionskennzeichen_bezeichnungen[5] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div>
                        &nbsp;
                    </div>
                    <div>
                        &nbsp;
                    </div>
                </div>
            </div>

        </div>
        <!-- Ende Dispodaten -->

        <div class="details-grid-container" style="margin-top: 10px;">

            <!-- Überschrift -->
            <div *ngIf="sichtbar('lblUeberschriftBehaelterdaten')" class="details-ueberschrift-left">
                &nbsp;
            </div>
            <div *ngIf="sichtbar('lblUeberschriftBehaelterdaten')" class="details-ueberschrift-right">
                Behälterdaten
            </div>
            
            <!-- nächste: Kunden-Nr. / Behälter / Fälligkeit -->
            <div>
                <!--<i class="fa-solid fa-signs-post"></i>-->&nbsp;
            </div>
            <div style="width: 100%">
                
                <div class="" [ngClass]="{'details-grid-tablelike-container': !app.inAppMode, 'details-grid-tablelike-container-inAppMode': app.inAppMode}">
                    <!-- zeile 1: Kunden-Nr. + Beh.Nr. -->
                    <div>
                        Kunden-Nr.:
                    </div>
                    <div>
                        {{lastclickedAuftrag.kundennummer}}
                        {{sichtbar('lblKundenNrBehaelterdaten') && lastclickedAuftrag.kundenposition != null ? '/ '+lastclickedAuftrag.kundenposition : null}}
                    </div>
                    <div>
                        Behälter-Nr.:
                    </div>
                    <div>
                        {{lastclickedAuftrag.behaelternummer}}
                    </div>
                    <!-- zeile 2: Behälter-BJ. + Inhalt -->
                    <div>
                        Baujahr:
                    </div>
                    <div>
                        {{lastclickedAuftrag.baujahr | datumFormat:'MM.YYYY':true}}
                    </div>
                    <div>
                        Nettoinhalt:
                    </div>
                    <div>
                        {{lastclickedAuftrag.fuellvolumen}} Liter
                    </div>
                    <!-- zeile 3: Hersteller und Lagerungsart -->
                    <div>
                        Hersteller:
                    </div>
                    <div>
                        {{lastclickedAuftrag.auftragsdatenHersteller.bezeichnung}}
                    </div>
                    <div>
                        Behältervolumen:
                    </div>
                    <div>
                        {{lastclickedAuftrag.behaeltervolumen}} Liter
                    </div>

                    <!--Lagerungsart: Variante für Zähler-->
                    <div *ngIf="sichtbar('lblLagerungsartZaehlerBehaelterdaten')">
                        Lagerungsart:
                    </div>
                    <div *ngIf="sichtbar('lblLagerungsartZaehlerBehaelterdaten')">
                        {{lagerungsarten[lastclickedAuftrag.lagerungsart] || 'unbekannt'}}
                    </div>
                    <!--Lagerungsart: Variante für Nicht-Zähler-->
                    <div *ngIf="!(sichtbar('lblLagerungsartBehaelterdaten')) || ['01', '03'].includes(lastclickedAuftrag.lagerungsart)">
                        {{lastclickedAuftrag.lagerungsart == '01' ? 'Tankfarbe:' : null}}<div *ngIf="['01', '03'].includes(lastclickedAuftrag.lagerungsart)" style="font-size: 0.25em;"><br></div>
                        <p-checkbox *ngIf="['01', '03'].includes(lastclickedAuftrag.lagerungsart)" label="oberirdisch" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(['01', '03'].includes(lastclickedAuftrag.lagerungsart))" label="oberirdisch" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div *ngIf="!(sichtbar('lblLagerungsartBehaelterdaten')) || ['01', '03'].includes(lastclickedAuftrag.lagerungsart)">
                        {{lastclickedAuftrag.lagerungsart == '01' ? lastclickedAuftrag.tankfarbe : null}}{{lastclickedAuftrag.lagerungsart == '01' ? '&nbsp;' : null}}<div *ngIf="['01', '03'].includes(lastclickedAuftrag.lagerungsart)" style="font-size: 0.25em;"><br></div>
                        <p-checkbox *ngIf="lastclickedAuftrag.lagerungsart == '02' || lastclickedAuftrag.lagerungsart >= '04'" label="erdgedeckt" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.lagerungsart == '02' || lastclickedAuftrag.lagerungsart >= '04')" label="erdgedeckt" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>

                    <!-- zeile 4: Pumpentyp
                    <div>
                        Pumpentyp:
                    </div>
                    <div>
                    </div>
                    <div>
                    </div>
                    <div>
                    </div>-->
                    <!-- zeile 5: Fälligkeitsdatum / Vertragart -->
                    <div>
                        Fälligkeitsdatum:
                    </div>
                    <div>
                        {{lastclickedAuftrag.endedatum | datumFormat:'DD.MM.YYYY':true}}
                    </div>
                    <!-- div immer anzeigen, aber nur bei Z mit Inhalt, sonst empty div -->
                    <div>
                        <span [style.display]="sichtbar('lblVertragsartBehaelterdaten') ? 'unset' : 'none'">Vertragsart:</span>
                    </div>
                    <div>
                        <span [style.display]="sichtbar('lblVertragsartBehaelterdaten') ? 'unset' : 'none'">{{lastclickedAuftrag.vertragartbezeichnung}}</span>
                    </div>
                    <!-- weitere DIVS nur bei Z -->
                    <div [style.display]="sichtbar('cbTerminabspracheBehaelterdaten') ? 'unset' : 'none'">
                        <p-checkbox *ngIf="lastclickedAuftrag.terminabspracheerforderlich == '1'" label="Terminabsprache" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.terminabspracheerforderlich == '1')" label="Terminabsprache" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div [style.display]="sichtbar('cbTechnischerStopBehaelterdaten') ? 'unset' : 'none'">
                        <p-checkbox *ngIf="lastclickedAuftrag.technischerLieferstopp == 'J'" label="Technischer Stop" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.technischerLieferstopp == 'J')" label="Technischer Stop" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div [style.display]="sichtbar('lblAbsatzKgBehaelterdaten') ? 'unset' : 'none'">
                        Absatz in KG:
                    </div>
                    <div [style.display]="sichtbar('lblAbsatzKgBehaelterdaten') ? 'unset' : 'none'">
                        {{lastclickedAuftrag.absatzKg}}
                    </div>

                    <!--  -->
                    <div [style.display]="sichtbar('lblLetzteAeusserePruefungBehaelterdaten') ? 'unset' : 'none'">
                        letzte ÄP:
                    </div>
                    <div [style.display]="sichtbar('lblLetzteAeusserePruefungBehaelterdaten') ? 'unset' : 'none'" pTooltip="letzte äußere Prüfung" tooltipPosition="left">
                        {{lastclickedAuftrag.letzteAeusserePruefung | datumOhneZeit}}
                    </div>
                    <div [style.display]="sichtbar('lblLetzteInnerePruefungBehaelterdaten') ? 'unset' : 'none'">
                        letzte IP:
                    </div>
                    <div [style.display]="sichtbar('lblLetzteInnerePruefungBehaelterdaten') ? 'unset' : 'none'" pTooltip="letzte innere Prüfung" tooltipPosition="left">
                        {{lastclickedAuftrag.letzteInnerePruefungAnlagenpruefung | datumOhneZeit}}
                    </div>

                </div>

                <div class="" [ngClass]="{'details-grid-tablelike-container': !app.inAppMode, 'details-grid-tablelike-container-inAppMode': app.inAppMode}">
                    <!--  -->
                    <div *ngIf="lastclickedAuftrag.tUEVDatum != null">
                        TÜV-Datum:
                    </div>
                    <div *ngIf="lastclickedAuftrag.tUEVDatum != null" pTooltip="TÜV-Datum" tooltipPosition="left">
                        {{lastclickedAuftrag.tUEVDatum | datumOhneZeit}}
                    </div>
                    <div *ngIf="lastclickedAuftrag.fabrikationszustand != null && lastclickedAuftrag.fabrikationszustand.length > 0">
                        Fabrikationszustand:
                    </div>
                    <div *ngIf="lastclickedAuftrag.fabrikationszustand != null && lastclickedAuftrag.fabrikationszustand.length > 0" pTooltip="Fabrikationszustand" tooltipPosition="left">
                        {{lastclickedAuftrag.fabrikationszustand}}
                    </div>

                    <div *ngIf="lastclickedAuftrag.letzteBewegung != null">
                        letzte Bewegung:
                    </div>
                    <div  *ngIf="lastclickedAuftrag.letzteBewegung != null" pTooltip="letzte Bewegung" tooltipPosition="left">
                        {{lastclickedAuftrag.letzteBewegung | datumOhneZeit}}
                    </div>

                </div>

                <div class="" [ngClass]="{'details-grid-tablelike-container': !app.inAppMode, 'details-grid-tablelike-container-inAppMode': app.inAppMode}">
                    <!--  -->
                    <div *ngIf="lastclickedAuftrag.umbauNummer != null" pTooltip="TÜV-Datum" tooltipPosition="left">
                        Umbau Behälter-Nr.:
                    </div>
                    <div *ngIf="lastclickedAuftrag.umbauNummer != null" >
                        {{lastclickedAuftrag.umbauNummer}}
                    </div>
                    <div *ngIf="lastclickedAuftrag.umbauBaujahr != null" >
                        Umbau Baujahr:
                    </div>
                    <div  *ngIf="lastclickedAuftrag.umbauBaujahr != null" >
                        {{lastclickedAuftrag.umbauBaujahr | datumFormat:'MM.YYYY':true}}
                    </div>
                    <div *ngIf="lastclickedAuftrag.auftragsdatenUmbauHersteller != null">
                        Umbau Hersteller:
                    </div>
                    <div *ngIf="lastclickedAuftrag.auftragsdatenUmbauHersteller != null">
                        {{lastclickedAuftrag.auftragsdatenUmbauHersteller.bezeichnung}}
                    </div>

                    <div *ngIf="lastclickedAuftrag.betriebsdruck != null && lastclickedAuftrag.betriebsdruck != 0">
                        Betriebsdruck max:
                    </div>
                    <div *ngIf="lastclickedAuftrag.betriebsdruck != null && lastclickedAuftrag.betriebsdruck != 0" pTooltip="TÜV-Datum" tooltipPosition="left">
                        {{lastclickedAuftrag.betriebsdruck}} bar
                    </div>
                    <div *ngIf="lastclickedAuftrag.fuellvolumenMax != null && lastclickedAuftrag.fuellvolumenMax != 0">
                        Füllvolumen max:
                    </div>
                    <div *ngIf="lastclickedAuftrag.fuellvolumenMax != null && lastclickedAuftrag.fuellvolumenMax != 0" pTooltip="Fabrikationszustand" tooltipPosition="left">
                        {{lastclickedAuftrag.fuellvolumenMax}} Liter
                    </div>

                </div>

                <div class="" [ngClass]="{'details-grid-tablelike-container': !app.inAppMode, 'details-grid-tablelike-container-inAppMode': app.inAppMode}">
                    <div *ngIf="lastclickedAuftrag.behaelterkennzeichen_1 != null">
                        <p-checkbox *ngIf="lastclickedAuftrag.behaelterkennzeichen_1 == true" label="{{ behaelterkennzeichen_bezeichnungen[0] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.behaelterkennzeichen_1 == true)" label="{{ behaelterkennzeichen_bezeichnungen[0] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div *ngIf="lastclickedAuftrag.behaelterkennzeichen_2 != null">
                        <p-checkbox *ngIf="lastclickedAuftrag.behaelterkennzeichen_2 == true" label="{{ behaelterkennzeichen_bezeichnungen[1] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.behaelterkennzeichen_2 == true)" label="{{ behaelterkennzeichen_bezeichnungen[1] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div *ngIf="lastclickedAuftrag.behaelterkennzeichen_3 != null">
                        <p-checkbox *ngIf="lastclickedAuftrag.behaelterkennzeichen_3 == true" label="{{ behaelterkennzeichen_bezeichnungen[2] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.behaelterkennzeichen_3 == true)" label="{{ behaelterkennzeichen_bezeichnungen[2] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div *ngIf="lastclickedAuftrag.behaelterkennzeichen_4 != null">
                        <p-checkbox *ngIf="lastclickedAuftrag.behaelterkennzeichen_4 == true" label="{{ behaelterkennzeichen_bezeichnungen[3] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.behaelterkennzeichen_4 == true)" label="{{ behaelterkennzeichen_bezeichnungen[3] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <!-- nä. zeile -->
                    <div *ngIf="lastclickedAuftrag.behaelterkennzeichen_5 != null">
                        <p-checkbox *ngIf="lastclickedAuftrag.behaelterkennzeichen_5 == true" label="{{ behaelterkennzeichen_bezeichnungen[4] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.behaelterkennzeichen_5 == true)" label="{{ behaelterkennzeichen_bezeichnungen[4] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div *ngIf="lastclickedAuftrag.behaelterkennzeichen_6 != null">
                        <p-checkbox *ngIf="lastclickedAuftrag.behaelterkennzeichen_6 == true" label="{{ behaelterkennzeichen_bezeichnungen[5] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.behaelterkennzeichen_6 == true)" label="{{ behaelterkennzeichen_bezeichnungen[5] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div *ngIf="lastclickedAuftrag.behaelterkennzeichen_7 != null">
                        <p-checkbox *ngIf="lastclickedAuftrag.behaelterkennzeichen_7 == true" label="{{ behaelterkennzeichen_bezeichnungen[6] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.behaelterkennzeichen_7 == true)" label="{{ behaelterkennzeichen_bezeichnungen[6] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                    <div *ngIf="lastclickedAuftrag.behaelterkennzeichen_8 != null">
                        <p-checkbox *ngIf="lastclickedAuftrag.behaelterkennzeichen_8 == true" label="{{ behaelterkennzeichen_bezeichnungen[7] }}" [ngModel]="true" readonly="true" [binary]="true"></p-checkbox>
                        <p-checkbox *ngIf="!(lastclickedAuftrag.behaelterkennzeichen_8 == true)" label="{{ behaelterkennzeichen_bezeichnungen[7] }}" [ngModel]="false" readonly="true" [binary]="true"></p-checkbox>
                    </div>
                </div>

            </div>

            <!-- die folgenden Felder nur, wenn Z -->
            <div class="details-grid-container" style="margin-top: 10px;" *ngIf="sichtbar('gbZählerinformationen')">
                <!-- Überschrift -->
                <div *ngIf="lastclickedAuftrag.fernabfragegeraet != null || lastclickedAuftrag.fernabfragegeraet != null" class="details-ueberschrift-left">
                    &nbsp;
                </div>
                <div *ngIf="lastclickedAuftrag.fernabfragegeraet != null || lastclickedAuftrag.fernabfragegeraet != null" class="details-ueberschrift-right">
                    Fernabfrage
                </div>

                <div *ngIf="lastclickedAuftrag.fernabfragegeraet != null || lastclickedAuftrag.fernabfragegeraet != null">
                    <div style="font-size: 0.25em;">
                        <br>
                    </div>
                    <i class="fa-regular fa-wifi"></i>
                </div>
                <div *ngIf="lastclickedAuftrag.fernabfragegeraet != null || lastclickedAuftrag.fernabfragegeraet != null" pTooltip="Tamo / Fernabfragegerät" tooltipPosition="left">
                    <div style="font-size: 0.25em;">
                        <br>
                    </div>
                    {{lastclickedAuftrag.fernabfragegeraet | phoneCanonical}}
                </div>

                <!-- -->
                <!-- Überschrift -->
                <div *ngIf="sichtbar('lblUeberschriftZaehlerstandort') && lastclickedAuftrag.name_1ZaehlerStandort != null" class="details-ueberschrift-left">
                   &nbsp;
                </div>
                <div *ngIf="sichtbar('lblUeberschriftZaehlerstandort') && lastclickedAuftrag.name_1ZaehlerStandort != null" class="details-ueberschrift-right">
                    Zählerstandort
                </div>

                <div *ngIf="sichtbar('lblZaehlerstandort') && lastclickedAuftrag.name_1ZaehlerStandort != null">
                    <i class="fa fa-watch-calculator"></i>
                </div>
                <div *ngIf="sichtbar('lblZaehlerstandort') && lastclickedAuftrag.name_1ZaehlerStandort != null" pTooltip="Zähler-Standort" tooltipPosition="left">
                    {{lastclickedAuftrag.name_1ZaehlerStandort}} {{lastclickedAuftrag.name_2ZaehlerStandort}}<br>
                    {{lastclickedAuftrag.strasseZaehlerStandort}}<br>
                    {{lastclickedAuftrag.plzZaehlerStandort}} {{lastclickedAuftrag.ortZaehlerStandort}} {{lastclickedAuftrag.ortzusatzZaehlerStandort}}
                </div>
                <!-- nächste -->
                <div *ngIf="sichtbar('lblTelefonZaehlerstandort') && lastclickedAuftrag.telefonZaehlerStandort != null">
                    <i class="fa-solid fa-phone"></i>
                </div>
                <div *ngIf="sichtbar('lblTelefonZaehlerstandort') && lastclickedAuftrag.telefonZaehlerStandort != null" pTooltip="Telefon" tooltipPosition="left">
                    <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonZaehlerStandort | phoneCanonical}}">{{lastclickedAuftrag.telefonZaehlerStandort | phoneCanonical}}</a>
                    <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonZaehlerStandort)">{{lastclickedAuftrag.telefonZaehlerStandort | phoneCanonical}}</a>
                </div>
                <!-- Tel. geschäftlich -->
                <div *ngIf="sichtbar('lblTelefonGeschaeftlichZaehlerstandort') && lastclickedAuftrag.telefonGeschaeftlichZaehlerStandort != null && lastclickedAuftrag.telefonGeschaeftlichZaehlerStandort != telefonZaehlerStandort">
                    <i class="fa-solid fa-briefcase"></i>
                </div>
                <div *ngIf="sichtbar('lblTelefonGeschaeftlichZaehlerstandort') && lastclickedAuftrag.telefonGeschaeftlichZaehlerStandort != null && lastclickedAuftrag.telefonGeschaeftlichZaehlerStandort != telefonZaehlerStandort" pTooltip="Telefon geschäftlich" tooltipPosition="left">
                    <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonGeschaeftlichZaehlerStandort | phoneCanonical}}">{{lastclickedAuftrag.telefonGeschaeftlichZaehlerStandort | phoneCanonical}}</a>
                    <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonGeschaeftlichZaehlerStandort)">{{lastclickedAuftrag.telefonGeschaeftlichZaehlerStandort | phoneCanonical}}</a>
                </div>
                <!-- Tel. privat -->
                <div *ngIf="sichtbar('lblTelefonPrivatZaehlerstandort') && lastclickedAuftrag.telefonPrivatZaehlerStandort != null && lastclickedAuftrag.telefonPrivatZaehlerStandort != telefonZaehlerStandort">
                    <i class="fa-solid fa-phone"></i>
                </div>
                <div *ngIf="sichtbar('lblTelefonPrivatZaehlerstandort') && lastclickedAuftrag.telefonPrivatZaehlerStandort != null && lastclickedAuftrag.telefonPrivatZaehlerStandort != telefonZaehlerStandort" pTooltip="Telefon privat" tooltipPosition="left">
                    <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonPrivatZaehlerStandort | phoneCanonical}}">{{lastclickedAuftrag.telefonPrivatZaehlerStandort | phoneCanonical}}</a>
                    <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonPrivatZaehlerStandort)">{{lastclickedAuftrag.telefonPrivatZaehlerStandort | phoneCanonical}}</a>
                </div>
                <!-- Tel. mobil -->
                <div *ngIf="sichtbar('lblTelefonMobilZaehlerstandort') && lastclickedAuftrag.telefonMobilZaehlerStandort != null && lastclickedAuftrag.telefonMobilZaehlerStandort != telefonZaehlerStandort">
                    <i class="fa-solid fa-mobile"></i>
                </div>
                <div *ngIf="sichtbar('lblTelefonMobilZaehlerstandort') && lastclickedAuftrag.telefonMobilZaehlerStandort != null && lastclickedAuftrag.telefonMobilZaehlerStandort != telefonZaehlerStandort" pTooltip="Telefon mobil" tooltipPosition="left">
                    <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonMobilZaehlerStandort | phoneCanonical}}">{{lastclickedAuftrag.telefonMobilZaehlerStandort | phoneCanonical}}</a>
                    <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonMobilZaehlerStandort)">{{lastclickedAuftrag.telefonMobilZaehlerStandort | phoneCanonical}}</a>
                </div>
                <!-- eMail -->
                <div *ngIf="sichtbar('lblEmailZaehlerstandort') && lastclickedAuftrag.eMailZaehlerStandort != null">
                    <i class="fa-solid fa-envelope"></i>
                </div>
                <div *ngIf="sichtbar('lblEmailZaehlerstandort') && lastclickedAuftrag.eMailZaehlerStandort != null" pTooltip="E-Mail" tooltipPosition="left">
                    <a *ngIf="app.inAppMode!=true && lastclickedAuftrag.eMailZaehlerStandort != null" href="mailto:{{lastclickedAuftrag.eMailZaehlerStandort}}">{{lastclickedAuftrag.eMailZaehlerStandort}}</a>
                    <a *ngIf="app.inAppMode==true && lastclickedAuftrag.eMailZaehlerStandort != null" style="cursor: pointer" (click)="eMailClicked(lastclickedAuftrag.eMailZaehlerStandort)">{{lastclickedAuftrag.eMailZaehlerStandort}}</a>
                </div>

                <!-- -->
                <!-- Überschrift -->
                <div *ngIf="sichtbar('lblUeberschriftRechnungsadresseZaehlerKunde') && lastclickedAuftrag.name_1ZaehlerKunde != null" class="details-ueberschrift-left">
                    &nbsp;
                </div>
                <div *ngIf="sichtbar('lblUeberschriftRechnungsadresseZaehlerKunde') && lastclickedAuftrag.name_1ZaehlerKunde != null" class="details-ueberschrift-right">
                    Rechnungsadresse
                </div>
                
                <div *ngIf="sichtbar('lblRechnungsadresseZaehlerKunde') && lastclickedAuftrag.name_1ZaehlerKunde != null">
                    <i class="fa fa-watch-calculator"></i>
                </div>
                <div *ngIf="sichtbar('lblRechnungsadresseZaehlerKunde') && lastclickedAuftrag.name_1ZaehlerKunde != null" pTooltip="Zähler-Kunde" tooltipPosition="left">
                    {{lastclickedAuftrag.name_1ZaehlerKunde}} {{lastclickedAuftrag.name_2ZaehlerKunde}}<br>
                    {{lastclickedAuftrag.strasseZaehlerKunde}}<br>
                    {{lastclickedAuftrag.plzZaehlerKunde}} {{lastclickedAuftrag.ortZaehlerKunde}} {{lastclickedAuftrag.ortzusatzZaehlerKunde}}
                </div>
                <!-- nächste -->
                <div *ngIf="sichtbar('lblTelefonZaehlerKunde') && lastclickedAuftrag.telefonZaehlerKunde != null">
                    <i class="fa-solid fa-phone"></i>
                </div>
                <div *ngIf="sichtbar('lblTelefonZaehlerKunde') && lastclickedAuftrag.telefonZaehlerKunde != null" pTooltip="Telefon" tooltipPosition="left">
                    <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonZaehlerKunde | phoneCanonical}}">{{lastclickedAuftrag.telefonZaehlerKunde | phoneCanonical}}</a>
                    <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonZaehlerKunde)">{{lastclickedAuftrag.telefonZaehlerKunde | phoneCanonical}}</a>
                </div>
                <!-- Tel. geschäftlich -->
                <div *ngIf="sichtbar('lblTelefonGeschaeftlichZaehlerKunde') && lastclickedAuftrag.telefonGeschaeftlichZaehlerKunde != null && lastclickedAuftrag.telefonGeschaeftlichZaehlerKunde != telefonZaehlerKunde">
                    <i class="fa-solid fa-briefcase"></i>
                </div>
                <div *ngIf="sichtbar('lblTelefonGeschaeftlichZaehlerKunde') && lastclickedAuftrag.telefonGeschaeftlichZaehlerKunde != null && lastclickedAuftrag.telefonGeschaeftlichZaehlerKunde != telefonZaehlerKunde" pTooltip="Telefon geschäftlich" tooltipPosition="left">
                    <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonGeschaeftlichZaehlerKunde | phoneCanonical}}">{{lastclickedAuftrag.telefonGeschaeftlichZaehlerKunde | phoneCanonical}}</a>
                    <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonGeschaeftlichZaehlerKunde)">{{lastclickedAuftrag.telefonGeschaeftlichZaehlerKunde | phoneCanonical}}</a>
                </div>
                <!-- Tel. privat -->
                <div *ngIf="sichtbar('lblTelefonPrivatZaehlerKunde') && lastclickedAuftrag.telefonPrivatZaehlerKunde != null && lastclickedAuftrag.telefonPrivatZaehlerKunde != telefonZaehlerKunde">
                    <i class="fa-solid fa-phone"></i>
                </div>
                <div *ngIf="sichtbar('lblTelefonPrivatZaehlerKunde') && lastclickedAuftrag.telefonPrivatZaehlerKunde != null && lastclickedAuftrag.telefonPrivatZaehlerKunde != telefonZaehlerKunde" pTooltip="Telefon privat" tooltipPosition="left">
                    <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonPrivatZaehlerKunde | phoneCanonical}}">{{lastclickedAuftrag.telefonPrivatZaehlerKunde | phoneCanonical}}</a>
                    <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonPrivatZaehlerKunde)">{{lastclickedAuftrag.telefonPrivatZaehlerKunde | phoneCanonical}}</a>
                </div>
                <!-- Tel. mobil -->
                <div *ngIf="sichtbar('lblTelefonMobilZaehlerKunde') && lastclickedAuftrag.telefonMobilZaehlerKunde != null && lastclickedAuftrag.telefonMobilZaehlerKunde != telefonZaehlerKunde">
                    <i class="fa-solid fa-mobile"></i>
                </div>
                <div *ngIf="sichtbar('lblTelefonMobilZaehlerKunde') && lastclickedAuftrag.telefonMobilZaehlerKunde != null && lastclickedAuftrag.telefonMobilZaehlerKunde != telefonZaehlerKunde" pTooltip="Telefon mobil" tooltipPosition="left">
                    <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonMobilZaehlerKunde | phoneCanonical}}">{{lastclickedAuftrag.telefonMobilZaehlerKunde | phoneCanonical}}</a>
                    <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonMobilZaehlerKunde)">{{lastclickedAuftrag.telefonMobilZaehlerKunde | phoneCanonical}}</a>
                </div>
                <!-- eMail -->
                <div *ngIf="sichtbar('lblEmailZaehlerKunde') && lastclickedAuftrag.eMailZaehlerKunde != null">
                    <i class="fa-solid fa-envelope"></i>
                </div>
                <div *ngIf="sichtbar('lblEmailZaehlerKunde') && lastclickedAuftrag.eMailZaehlerKunde != null" pTooltip="E-Mail" tooltipPosition="left">
                    <a *ngIf="app.inAppMode!=true && lastclickedAuftrag.eMailZaehlerKunde != null" href="mailto:{{lastclickedAuftrag.eMailZaehlerKunde}}">{{lastclickedAuftrag.eMailZaehlerKunde}}</a>
                    <a *ngIf="app.inAppMode==true && lastclickedAuftrag.eMailZaehlerKunde != null" style="cursor: pointer" (click)="eMailClicked(lastclickedAuftrag.eMailZaehlerKunde)">{{lastclickedAuftrag.eMailZaehlerKunde}}</a>
                </div>

            </div>

        </div>

        <div *ngIf="sichtbar('lblUeberschriftZaehlerdaten') && (lastclickedAuftrag.zaehlerKundennummer != null || lastclickedAuftrag.zaehlernummer != null)" class="details-grid-container">
            <div class="details-ueberschrift-left">
                <!--icon?-->&nbsp;
            </div>
            <div class="details-ueberschrift-right">
                Zählerdaten
            </div>

            <div>
                <!--icon?-->&nbsp;
            </div>
            <div style="width: 100%">
                
                <div class="" [ngClass]="{'details-grid-tablelike-container': !app.inAppMode, 'details-grid-tablelike-container-inAppMode': app.inAppMode}">
                    <!-- zeile 1: Kunden-Nr. + Beh.Nr. -->
                    <div>
                        Zähler-Kunden-Nr.:
                    </div>
                    <div>
                        {{lastclickedAuftrag.zaehlerKundennummer}} {{sichtbar('lblZaehlerKundenNr') && lastclickedAuftrag.zaehlerKundenposition != null ? '/ '+lastclickedAuftrag.zaehlerKundenposition : null}}
                    </div>
                    <div>
                        Zähler-Nr.:
                    </div>
                    <div>
                        {{lastclickedAuftrag.zaehlernummer}}
                    </div>
                    <!-- nä. zeile -->
                    <div>
                        Baujahr:
                    </div>
                    <div>
                        {{lastclickedAuftrag.zaehlerbaujahr | datumFormat:'MM.YYYY':true}}
                    </div>
                    <div>
                        Zaehlergröße:
                    </div>
                    <div>
                        {{lastclickedAuftrag.zaehlergroesse}}
                    </div>
                    <!-- nä. zeile -->
                    <div>
                        Hersteller:
                    </div>
                    <div>
                        {{lastclickedAuftrag.zaehlerhersteller}}
                    </div>
                    <div>
                        Bauart:
                    </div>
                    <div>
                        {{lastclickedAuftrag.zaehlerbauart}}
                    </div>
                    <!-- nä. zeile -->
                    <div>
                        Eichdatum:
                    </div>
                    <div>
                        {{lastclickedAuftrag.zaehlereichdatum | datumOhneZeit}}
                    </div>
                    <div>
                        &nbsp;
                    </div>
                    <div>
                        &nbsp;
                    </div>

                </div>
            </div>

        </div>

   
    </ng-container>
    <ng-template pTemplate="footer">
        <br>
        <button pButton *ngIf="debugMode==true" type="button" label="dbg" icon="fa-solid fa-debug" iconPos="left" class="p-button-warning" style="float:left" (click)="debugLastClickedAuftrag()"></button>
        <button pButton type="button" label="Aufgabe starten" icon="fa-solid fa-clipboard-list" iconPos="left" class="p-button-success" style="float:left" (click)="aufgabeStartenClicked(lastclickedAuftrag.id)"></button>

        <button pButton  *ngIf="app.inAppMode != true" type="button" label="Vorabdruck" icon="fa-solid fa-print" iconPos="left" (click)="vorabdruckClicked(lastclickedAuftrag.id)"></button>

        <button pButton type="button" label="Navigation" icon="fa-solid fa-diamond-turn-right" iconPos="left" (click)="navigationClicked(lastclickedAuftrag.id)"></button>

        <button pButton *ngIf="app.inAppMode != true && benutzer != null && (benutzer.istAdmin == true || benutzer.disponieren == true)" type="button" label="Disponieren" icon="fa-regular fa-calendar" iconPos="left" (click)="app.dispositionStart(lastclickedAuftrag.id)"></button>

        <!-- button mit stacked icons -->
        <button pButton style="padding: 0.25em; padding-right: 1em;"
        *ngIf="app.inAppMode != true && lastclickedAuftrag_in_Routenplanung != null && lastclickedAuftrag_in_Routenplanung == true" type="button" label="{{benutzer != null && (benutzer.istAdmin == true || benutzer.disponieren == true) ? 'Markierung aufheben' : 'Route entfernen'}}" iconPos="left" (click)="demarkierenClicked(lastclickedAuftrag.id)">
            <span class="fa-stack">
              <i class="fa-solid fa-route fa-stack-1x"></i>
              <i class=" fa-solid fa-slash fa-stack-1x"></i>
            </span>
        </button>

        <button pButton *ngIf="app.inAppMode != true && lastclickedAuftrag_in_Routenplanung != null && lastclickedAuftrag_in_Routenplanung == false" type="button" label="{{benutzer != null && (benutzer.istAdmin == true || benutzer.disponieren == true) ? 'Auftrag markieren' : 'Route hinzufügen'}}" icon="fa-solid fa-route" iconPos="left" (click)="markierenClicked(lastclickedAuftrag.id)"></button>

        <!--
            AEP can-food
            IP  bullseye-pointer
            allg Reparatur toolbox
            Anstrich brush
            Rohrleitungsprüfung pipe-circle-check
            Sicherheitsventil pipe-valve
            Verdampfer droplet
            Wartung screwdriver-wrench
        -->
        <!-- Versuch, AEP aus 2 Icons zusammenzusetzen
        <span class="fa-stack fa-2x">
            <i class="fa fa-map-marker fa-stack-2x" style="color: #08f; font-size: 2em;"></i>

            <i class="fa fa-thin fa-can-food fa-stack-1x" style="color: white; font-size: 1em; margin-left: 1.25px; margin-top: -2.25px;"></i>

            <i class="fa fa-can-food fa-stack-1x" style="color: white; font-size: 0.75em; margin-left: 1px; margin-top: -2px;"></i>
        </span>     
        -->
        
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="dialogEditNotizShow" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">
    <ng-template pTemplate="header">
        <div class="details-grid-container">
            <!-- zeile 1 -->
            <div>
                <i class="fa fa-{{ getLeistungForAuftrag(lastclickedAuftrag).icon }} fa-xl"></i>
            </div>
            <div>
                <big>{{ getLeistungForAuftrag(lastclickedAuftrag).bezeichnung }}:</big>
            </div>
        </div>
    </ng-template>
    <ng-container *ngIf="lastclickedAuftrag != null">
        <div class="details-grid-container">
            <!-- zeile 1: Behälterstandort -->
            <div>
                <i class="fa fa-location"></i>
            </div>
            <div>
                {{lastclickedAuftrag.name_1Behaelterstandort}} {{lastclickedAuftrag.name_2Behaelterstandort}}<br>
                {{lastclickedAuftrag.strasseBehaelterstandort}}<br>
                {{lastclickedAuftrag.plzBehaelterstandort}} {{lastclickedAuftrag.ortBehaelterstandort}} {{lastclickedAuftrag.ortzusatzBehaelterstandort}}
            </div>
            <!-- nächste -->
            <div *ngIf="lastclickedAuftrag.telefonBehaelterstandort != null">
                <i class="fa-solid fa-phone"></i>
            </div>
            <div *ngIf="lastclickedAuftrag.telefonBehaelterstandort != null">
                <a *ngIf="app.inAppMode!=true" href="tel:{{lastclickedAuftrag.telefonBehaelterstandort | phoneCanonical}}">{{lastclickedAuftrag.telefonBehaelterstandort | phoneCanonical}}</a>
                <a *ngIf="app.inAppMode==true" style="cursor: pointer" (click)="phoneNrClicked(lastclickedAuftrag.telefonBehaelterstandort)">{{lastclickedAuftrag.telefonBehaelterstandort | phoneCanonical}}</a>
            </div>
        </div>

        <div class="details-grid-container" style="margin-top: 10px;">
            <!-- nächste -->
            <div>
                <i class="fa-solid fa-circle-info"></i>
            </div>
            <div>
                <span class="p-float-label">
                    <textarea #bemerkungPos style="width:100%; padding-top: 0.5em; padding-bottom: 0.5em;" [rows]="4" pInputTextarea 
                    [(ngModel)]="lastclickedAuftrag.notizDienstleister"
                    ></textarea><!--kein autoResize="autoResize" sonst optisches Problem beim wieder-reinkommen-->
                    <label>Notiz</label>
                </span>
            </div>
        </div>

    </ng-container>
    <ng-template pTemplate="footer">
        <br>
        <button pButton type="button" label="Speichern" iconPos="left" (click)="notizSpeichernClicked()"></button>
    </ng-template>
</p-dialog>

<!--#37658 Prototyp für neue Schnell-Markierung-->
<p-dialog [visible]="lastclickedAuftrag!=null && false" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{'min-width': '100vw', position: 'absolute', bottom: '0px'}">
    <ng-template pTemplate="header">
        <div class="details-grid-container">
            <!-- zeile 1 -->
            <div>
                <i class="fa fa-{{ getLeistungForAuftrag(lastclickedAuftrag).icon }} fa-xl"></i>
            </div>
            <div>
                <big>{{ getLeistungForAuftrag(lastclickedAuftrag).bezeichnung }}:</big>
            </div>
        </div>
    </ng-template>
    <ng-container *ngIf="lastclickedAuftrag != null">
        <div class="details-grid-container">
            <!-- zeile 1: Behälterstandort -->
            <div>
                <i class="fa fa-location"></i>
            </div>
            <div>
                {{lastclickedAuftrag.name_1Behaelterstandort}} {{lastclickedAuftrag.name_2Behaelterstandort}}<br>
                {{lastclickedAuftrag.strasseBehaelterstandort}}<br>
                {{lastclickedAuftrag.plzBehaelterstandort}} {{lastclickedAuftrag.ortBehaelterstandort}} {{lastclickedAuftrag.ortzusatzBehaelterstandort}}
            </div>
        </div>

    </ng-container>
    <ng-template pTemplate="footer">
        <br>
        <button pButton type="button" label="Details" iconPos="left"></button>
        <button pButton type="button" label="Markieren 10sek ..." iconPos="right"></button>
    </ng-template>
</p-dialog>

<!--Dokumente Popup-->
<p-dialog  [(visible)]="dokumenteDialogShow" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}" modal="true">
    <ng-template pTemplate="header">
      <div>
        <span class="fa-stack">
          <i class="fa-solid fa-file"></i>        
        </span>
        <big>Dokumente:</big>
      </div>
  </ng-template>
    <table  class="aufrags-dokumente-table" style="margin-top: 10px;">
      <thead>
          <tr>
              <th>Datei </th>
              <th>Format</th>
              <th>Stand</th>
              <th style="width: 90px;">Download</th>
          </tr>
      </thead>
      <tbody>          
        <tr *ngFor="let auftrDok of lastclickedAuftrag?.auftragsDokumente; let i = index">
              <td>{{auftrDok.bezeichnung}}</td>
              <td>{{auftrDok.dateiendung}}</td>
              <td>{{auftrDok.modified | datumFormat:'DD.MM.YYYY':true}}</td>
              <td><button pButton type="button" icon="fa-solid fa-download" iconPos="left" (click)="downloadAuftragsDokument(auftrDok.id)"></button></td>
          </tr>
      </tbody>
  </table>     
  </p-dialog>
